import { render, staticRenderFns } from "./SalaryInfo.vue?vue&type=template&id=17f717e1&scoped=true"
import script from "./SalaryInfo.vue?vue&type=script&lang=js"
export * from "./SalaryInfo.vue?vue&type=script&lang=js"
import style0 from "./SalaryInfo.vue?vue&type=style&index=0&id=17f717e1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f717e1",
  null
  
)

export default component.exports